import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"companyPanel"},[(_vm.companies.length > 0)?_c('div',{staticClass:"companies"},_vm._l((_vm.companies),function(c,index){return _c('CompanyCard',{key:index,attrs:{"company":c}})}),1):_c('div',[_c(VSkeletonLoader,{attrs:{"type":"list-item-three-line"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }